<div *ngIf="cart" class="flow-root">
    <ul role="list" class="divide-y divide-gray-200">
        <ng-container *ngFor="let line of cart.lines; trackBy: trackByFn">
            <li class="py-6 flex">
                <div class="flex-shrink-0 w-24 h-24 border border-gray-200 rounded-md overflow-hidden">
                    <img [src]="line.featuredAsset | assetPreview:'thumb'" [alt]="line.productVariant.name"
                         class="rounded"/>
                </div>

                <div class="ml-4 flex-1 flex flex-col">
                    <div>
                        <div class="flex justify-between text-base font-medium text-gray-900">
                            <h3>
                                <a [routerLink]="['/products', line.productVariant]">
                                    {{ line.productVariant.name }}
                                </a>
                            </h3>
                            <p class="ml-4">
                                <span *ngIf="isDiscounted(line)" class="line-through text-disabled text-sm mr-1">{{ line.linePriceWithTax | formatPrice }}</span>
                                <span>{{ (isDiscounted(line) ? line.discountedLinePriceWithTax : line.linePriceWithTax) | formatPrice }}</span>
                            </p>
                        </div>
                        <span *ngIf="line.customFields?.installationRequested"
                              class="mt-1 inline-flex items-center self-start text-[11px] font-semibold px-2 py-0.5 rounded-full bg-primary/10 text-primary w-fit">
                            {{ 'product.installationIncluded' | translate }}
                        </span>
                    </div>
                    <div class="flex-1 flex items-center justify-between text-sm text-gray-600">
                        <div class="flex space-x-4">
                            <button class="btn btn-sm"
                                    *ngIf="canAdjustQuantities"
                                    (click)="decrement(line)">
                                <fa-icon aria-label="Remove 1" icon="minus"></fa-icon>
                            </button>
                            <div class="qty">{{ line.quantity }}</div>
                            <button class="btn btn-sm"
                                    *ngIf="canAdjustQuantities"
                                    (click)="increment(line)">
                                <fa-icon aria-label="Add 1" icon="plus"></fa-icon>
                            </button>
                        </div>
                        <div class="total">
                            <div>
                                <span *ngIf="isDiscounted(line)" class="line-through text-disabled text-xs mr-1">{{ line.unitPriceWithTax | formatPrice }}</span>
                                <span>{{ (isDiscounted(line) ? line.discountedUnitPriceWithTax : line.unitPriceWithTax) | formatPrice }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ng-container>

    </ul>
</div>
